module.exports = __webpack_public_path__ + "static/media/icon_exibicao.46cdaac0.svg";